<script setup lang="ts">
import { URL_IMAGE } from '@/config/constants'
import { toggleShowModalBasketHappy } from '@/happyTheme/utils/modalBasket/toggleShowModalBasketHappy'
import InputQuantityBasketHappy from './inputQuantityBasketHappy.vue'
import { getPrice } from '@/utils/product/getPrice'
import { convertPriceToEuroHappy } from '@/happyTheme/utils/product/convertPriceToEuroHappy'
import { basketCart } from '@/event/basket/basketCart'
import { numberBasket } from '@/event/basketBus'
import { messageAlertElementBasketHappy } from '@/happyTheme/event/modalBasket/messageAlertElementBasketHappy'
import AlertElementBasketHappy from './alert/AlertElementBasketHappy.vue'
import { useRouter } from 'vue-router'
import { showModalBasketHappyTransition } from '@/happyTheme/event/modalBasket/showModalBasketHappy'
import { totalPriceBasket } from '@/happyTheme/event/modalBasket/totalPriceBasket'
import { isAuthenticated } from '@/event/account/auth/authentification'
import AlertAuthBasketHappy from './alert/AlertAuthBasketHappy.vue'
import {
    showAlertAuthBasket,
    showAlertAuthBasketTransition
} from '@/happyTheme/event/modalBasket/showAlertValidateBasket'
import { storeIsOpen } from '@/event/closeBus'

const router = useRouter()

function validateOrder() {
    if (isAuthenticated.value) {
        toggleShowModalBasketHappy()
        setTimeout(() => {
            router.push('/basket/order')
        }, 350)
    } else {
        showAlertAuthBasket.value = true
        setTimeout(() => {
            showAlertAuthBasketTransition.value = true
        }, 300)
    }
}
</script>

<template>
    <section class="section-modal-basket-happy">
        <section
            class="section-modal-basket-overlay-happy"
            @click="toggleShowModalBasketHappy()"
        ></section>

        <AlertElementBasketHappy
            v-if="messageAlertElementBasketHappy.message.length !== 0"
        />

        <AlertAuthBasketHappy v-if="showAlertAuthBasket" />

        <transition
            name="basket"
            enter-active-class="transition-all duration-300 ease-out"
            enter-from-class="-translate-y-full opacity-0"
            enter-to-class="translate-y-0 opacity-100"
            leave-active-class="transition-all duration-300 ease-out"
            leave-from-class="translate-y-0 opacity-100"
            leave-to-class="-translate-y-full opacity-0"
        >
            <section
                class="section-modal-basket-content-happy"
                v-if="showModalBasketHappyTransition"
            >
                <section class="section-modal-basket-design-happy">
                    <div class="div-modal-basket-title-happy">
                        <p class="p-basket-happy">Panier</p>
                        <svg
                            @click="toggleShowModalBasketHappy()"
                            class="svg-cross-modal-basket-happy"
                            viewBox="0 0 30 30"
                            xmlns="http://www.w3.org/2000/svg"
                        >
                            <path
                                d="M23.75 6.25L6.25 23.75M6.25004 6.25L23.75 23.75"
                                stroke-width="3"
                                stroke-linecap="round"
                                stroke-linejoin="round"
                            />
                        </svg>
                    </div>

                    <section v-if="basketCart.length !== 0">
                        <div class="div-modal-basket-content-happy">
                            <div
                                class="div-product-basket-happy"
                                :class="{
                                    'div-product-basket-border-happy':
                                        i !== basketCart.length - 1
                                }"
                                v-for="(p, i) in basketCart"
                                :key="i"
                            >
                                <div class="flex">
                                    <img
                                        class="img-product-basket-happy"
                                        :src="`${URL_IMAGE}${p.product_image}`"
                                        alt=""
                                    />
                                    <div class="div-content-product-basket-happy">
                                        <p class="name-product-basket-happy">
                                            {{ p.product }}
                                        </p>
                                        <div
                                            class="div-content-information-product-happy"
                                        >
                                            <InputQuantityBasketHappy :index="i" />
                                            <p class="price-basket-product-happy">
                                                {{ getPrice(p.total_price) }}
                                            </p>
                                        </div>
                                    </div>
                                </div>

                                <div
                                    class="div-option-basket-happy"
                                    v-if="Object.keys(p.groupedOptions).length > 0"
                                    v-for="(o, _i) in p.groupedOptions"
                                >
                                    <svg
                                        fill="none"
                                        viewBox="0 0 14 11"
                                        class="svg-option-basket-happy"
                                        xmlns="http://www.w3.org/2000/svg"
                                    >
                                        <path
                                            d="M9.43483 4.35783L12.2604 7.18344M12.2604 7.18344L9.43483 10.009M12.2604 7.18344H2.01761C1.43241 7.18344 0.958008 6.70906 0.958008 6.12384V1.53223"
                                            stroke-width="1.5"
                                            stroke-linecap="round"
                                            stroke-linejoin="round"
                                        />
                                    </svg>
                                    <div class="div-content-option-basket-happy">
                                        <p
                                            class="text-wrap text-[14px] leading-[16px] font-semibold"
                                        >
                                            {{ _i + ' :' }}
                                        </p>
                                        <span
                                            v-if="o.length !== 0"
                                            v-for="(ov, iov) in o"
                                            class="text-[13px] leading-[17px] whitespace-nowrap flex flex-wrap"
                                        >
                                            {{ ov.productName }}
                                            <span
                                                v-if="Number(ov.price) !== 0"
                                                class="span-ov-price-happy"
                                            >
                                                {{
                                                    ' (' +
                                                    getPrice(Number(ov.price)) +
                                                    ')'
                                                }}
                                            </span>
                                            <span v-if="iov !== o.length - 1">,</span>
                                        </span>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <button
                            class="bottom-basket-modal-happy"
                            @click="validateOrder()"
                            :disabled="storeIsOpen === false"
                        >
                            <div
                                class="flex items-center justify-center p-1 bg-border-red-happy-light w-full text-center text-bg-happy-light"
                                v-if="storeIsOpen === false"
                            >
                                <p class="font-semibold">Le magasin est fermé</p>
                            </div>
                            <div
                                class="flex items-center gap-2 justify-between w-full px-3"
                            >
                                <div class="relative flex justify-center">
                                    <svg
                                        class="svg-basket-happy"
                                        viewBox="0 0 30 34"
                                        fill="none"
                                        xmlns="http://www.w3.org/2000/svg"
                                    >
                                        <path
                                            d="M29.3059 32.1838L27.4064 8.67824C27.3689 8.21454 26.9817 7.85727 26.5164 7.85727H21.4172V6.7269C21.4172 3.01767 18.4393 0 14.7299 0H14.6121C10.9028 0 7.84552 3.01767 7.84552 6.7269V7.85727H2.82555C2.36031 7.85727 1.97304 8.21454 1.93554 8.67824L0.0307451 32.2501C0.0106257 32.4986 0.0953889 32.7441 0.264439 32.9273C0.43349 33.1106 0.671589 33.2148 0.92076 33.2148H28.4212C28.4219 33.2148 28.4229 33.2148 28.4236 33.2148C28.9168 33.2148 29.3165 32.8152 29.3165 32.322C29.3165 32.2749 29.3129 32.2288 29.3059 32.1838ZM9.63126 6.7269C9.63126 4.00233 11.8875 1.78574 14.6121 1.78574H14.7299C17.4545 1.78574 19.6314 4.00233 19.6314 6.7269V7.85727H9.63126V6.7269Z"
                                        />
                                    </svg>
                                    <p class="p-count-basket-happy">
                                        {{ numberBasket }}
                                    </p>
                                </div>
                                <p class="font-semibold">Valider mon panier</p>
                                <p class="price-product-basket-happy">
                                    {{ convertPriceToEuroHappy(totalPriceBasket) }}
                                </p>
                            </div>
                        </button>
                    </section>
                    <section v-else class="h-14 flex items-center justify-center">
                        <p class="font-semibold">Le panier est vide</p>
                    </section>
                </section>
            </section>
        </transition>
    </section>
</template>

<style scoped>
.section-modal-basket-happy {
    @apply w-screen h-full fixed flex flex-col items-center top-0 left-0 z-30;
}

.section-modal-basket-overlay-happy {
    @apply w-screen h-full;
}

.section-modal-basket-content-happy {
    @apply absolute top-14 z-10 p-1 w-full;
    @apply flex flex-col;
}

.section-modal-basket-design-happy {
    @apply rounded-md shadow-sm flex flex-col border-2 overflow-hidden;

    @apply happy-light:border-border-gray-happy-light happy-dark:border-border-gray-happy-light;
    @apply happy-urban-dark-red:border-urban-red;
    @apply happy-urban-light-red:border-urban-red;
    @apply happy-orange-light:border-bg-orange;
    @apply happy-orange-dark:border-bg-orange;
    @apply happy-fresh-mint:border-bg-mint;
    @apply happy-bee-light:border-urban-dark;
    @apply happy-bee-dark:border-bee-yellow;
    @apply happy-earth-stone:border-earth-card-dark;
    @apply happy-scorched-earth:border-scorched-earth-yellow;
    @apply happy-sand-sky:border-sand-blue;
    @apply happy-gray-sand:border-gray-sand-gray-dark;
    @apply happy-purple-gradient:border-pink-dark;

    @apply happy-dark:bg-text-dark-happy-light happy-dark:shadow-bg-happy-light;
    @apply happy-light:bg-bg-happy-light happy-light:shadow-text-dark-happy-light;
    @apply happy-urban-dark-red:bg-urban-dark happy-urban-dark-red:shadow-bg-happy-light;
    @apply happy-urban-light-red:bg-bg-happy-light happy-urban-light-red:shadow-urban-dark;
    @apply happy-orange-light:bg-bg-happy-light happy-orange-light:shadow-urban-dark;
    @apply happy-orange-dark:bg-urban-dark happy-orange-dark:shadow-bg-happy-light;
    @apply happy-fresh-mint:bg-bg-happy-light happy-fresh-mint:shadow-urban-dark;
    @apply happy-bee-light:bg-bg-happy-light happy-bee-light:shadow-bg-happy-light;
    @apply happy-bee-dark:bg-urban-dark happy-bee-dark:shadow-bg-happy-light;
    @apply happy-earth-stone:bg-bg-earth happy-earth-stone:shadow-bg-happy-light;
    @apply happy-scorched-earth:bg-bg-scorched-earth happy-scorched-earth:shadow-bg-happy-light;
    @apply happy-sand-sky:bg-bg-sand happy-sand-sky:shadow-bg-happy-light;
    @apply happy-gray-sand:bg-gray-sand-gray-light happy-gray-sand:shadow-bg-happy-light;
    @apply happy-purple-gradient:bg-no-repeat happy-purple-gradient:bg-gradient-to-t happy-purple-gradient:to-bg-purple-dark happy-purple-gradient:from-bg-purple-light happy-purple-gradient:text-bg-happy-light;
}

.div-modal-basket-title-happy {
    @apply bg-border-gray-happy-light rounded-t-sm p-2 text-text-dark-happy-light font-semibold flex justify-between items-center;
}

.svg-cross-modal-basket-happy {
    @apply w-7 h-7 stroke-text-dark-happy-light;
}
.svg-cross-modal-basket-happy:active,
.svg-cross-modal-basket-happy:focus {
    @apply stroke-border-red-happy-light;
    @apply happy-orange-light:stroke-bg-orange;
    @apply happy-orange-dark:stroke-bg-orange;
    @apply happy-fresh-mint:stroke-bg-mint;
    @apply happy-bee-light:stroke-bee-yellow;
    @apply happy-bee-dark:stroke-bee-yellow;
    @apply happy-earth-stone:stroke-earth-card-dark;
    @apply happy-scorched-earth:stroke-scorched-earth-red;
    @apply happy-sand-sky:stroke-sand-blue-dark;
    @apply happy-gray-sand:stroke-white;
    @apply happy-purple-gradient:stroke-pink-light;
}

.div-modal-basket-content-happy {
    @apply flex flex-col max-h-[10rem] overflow-auto;
}

.div-product-basket-happy {
    @apply p-2 flex max-w-full flex-col gap-2;
}

.div-product-basket-border-happy {
    @apply border-b happy-light:border-text-dark-happy-light happy-dark:border-bg-happy-light;
}

.img-product-basket-happy {
    @apply max-w-14 object-contain;
}

.div-content-product-basket-happy {
    @apply px-1 min-w-0 flex-1;
}

.name-product-basket-happy {
    @apply pt-1 font-bold;
}

.div-content-information-product-happy {
    @apply flex justify-between;
}

.price-basket-product-happy {
    @apply font-semibold;
}

.div-option-basket-happy {
    @apply pl-6 flex items-start gap-1;
}

.svg-option-basket-happy {
    @apply min-w-4 max-w-4 min-h-4 max-h-4;
    @apply happy-light:stroke-text-dark-happy-light happy-dark:stroke-bg-happy-light;
}

.div-content-option-basket-happy {
    @apply flex flex-wrap items-baseline gap-1 transition-all duration-500 ease-out;
}

.span-ov-price-happy {
    @apply whitespace-pre text-border-red-happy-light font-semibold;
    @apply happy-scorched-earth:text-scorched-earth-yellow;
}

.bottom-basket-modal-happy {
    @apply bg-text-basket-option-light-happy text-bg-happy-light w-full flex gap-2 flex-col items-center border-t py-2   min-h-12 justify-center;
    @apply happy-urban-light-red:bg-urban-red;
    @apply happy-urban-dark-red:bg-urban-red;
    @apply happy-orange-light:bg-bg-orange;
    @apply happy-orange-dark:bg-bg-orange;
    @apply happy-fresh-mint:bg-bg-mint;
    @apply happy-bee-light:bg-bee-yellow happy-bee-light:text-urban-dark;
    @apply happy-bee-dark:bg-bee-yellow happy-bee-dark:text-urban-dark;
    @apply happy-earth-stone:bg-earth-card-dark happy-earth-stone:text-bg-happy-light happy-earth-stone:border-earth-card-dark;
    @apply happy-scorched-earth:bg-scorched-earth-yellow happy-scorched-earth:text-urban-dark happy-scorched-earth:border-scorched-earth-red;
    @apply happy-sand-sky:bg-sand-blue happy-sand-sky:text-urban-dark happy-sand-sky:border-sand-blue;
    @apply happy-gray-sand:bg-gray-sand-gray-dark happy-gray-sand:text-urban-dark happy-gray-sand:border-gray-sand-gray-dark;
    @apply happy-purple-gradient:bg-bg-purple-dark happy-purple-gradient:text-bg-happy-light happy-purple-gradient:border-bg-purple-dark;
}

.bottom-basket-modal-happy:enabled:active,
.bottom-basket-modal-happy:enabled:focus {
    @apply bg-banner-gray-component-happy-light text-text-dark-happy-light  happy-light:border-text-dark-happy-light happy-dark:border-bg-happy-light;
    @apply happy-urban-dark-red:border-urban-red-dark happy-urban-dark-red:bg-urban-red-dark happy-urban-dark-red:text-bg-happy-light;
    @apply happy-urban-light-red:border-urban-red-dark happy-urban-light-red:bg-urban-red-dark happy-urban-light-red:text-bg-happy-light;
    @apply happy-orange-light:border-bg-orange-dark happy-orange-light:bg-bg-orange-dark happy-orange-light:text-bg-happy-light;
    @apply happy-orange-dark:border-bg-orange-dark happy-orange-dark:bg-bg-orange-dark happy-orange-dark:text-bg-happy-light;
    @apply happy-fresh-mint:border-bg-mint-dark happy-fresh-mint:bg-bg-mint-dark happy-fresh-mint:text-bg-happy-light;
    @apply happy-bee-light:border-bee-yellow-dark happy-bee-light:bg-bee-yellow-dark happy-bee-light:text-bg-happy-light;
    @apply happy-bee-dark:border-bee-yellow-dark happy-bee-dark:bg-bee-yellow-dark happy-bee-dark:text-bg-happy-light;
    @apply happy-earth-stone:border-earth-card happy-earth-stone:bg-earth-card happy-earth-stone:text-urban-dark;
    @apply happy-scorched-earth:border-scorched-earth-red happy-scorched-earth:bg-scorched-earth-red happy-scorched-earth:text-bg-happy-light;
    @apply happy-sand-sky:border-sand-blue-dark happy-sand-sky:bg-sand-blue-dark happy-sand-sky:text-bg-happy-light;
    @apply happy-gray-sand:bg-gray-sand-gray-light happy-gray-sand:text-bg-happy-light;
    @apply happy-purple-gradient:border-pink-light happy-purple-gradient:bg-pink-light happy-purple-gradient:text-urban-dark;
}

.bottom-basket-modal-happy:enabled:active div .price-product-basket-happy,
.bottom-basket-modal-happy:enabled:focus div .price-product-basket-happy {
    @apply happy-bee-light:text-bg-happy-light;
    @apply happy-bee-dark:text-bg-happy-light;
    @apply happy-scorched-earth:text-bg-happy-light;

    @apply happy-purple-gradient:text-urban-dark;
}
.bottom-basket-modal-happy:disabled {
    @apply bg-border-gray-happy-light  text-text-dark-happy-light cursor-not-allowed happy-light:border-text-dark-happy-light happy-dark:border-bg-happy-light;
}

.svg-basket-happy {
    @apply w-6 h-6 fill-button-yellow-happy-light;
    @apply happy-bee-light:fill-urban-dark;
    @apply happy-bee-dark:fill-urban-dark;
    @apply happy-scorched-earth:fill-scorched-earth-red;
    @apply happy-gray-sand:fill-urban-dark;
    @apply happy-purple-gradient:fill-bg-happy-light;
}

.bottom-basket-modal-happy:enabled:active div .svg-basket-happy,
.bottom-basket-modal-happy:enabled:focus div .svg-basket-happy {
    @apply happy-scorched-earth:fill-scorched-earth-yellow;
    @apply happy-purple-gradient:fill-bg-purple-dark;
}

.p-count-basket-happy {
    @apply absolute text-[14px] font-bold text-text-dark-happy-light top-1;
    @apply happy-bee-light:text-bg-happy-light;
    @apply happy-bee-dark:text-bg-happy-light;
    @apply happy-scorched-earth:text-bg-happy-light;
    @apply happy-gray-sand:text-bg-happy-light;
    @apply happy-purple-gradient:text-urban-dark;
}

.bottom-basket-modal-happy:enabled:active div div .p-count-basket-happy,
.bottom-basket-modal-happy:enabled:focus div div .p-count-basket-happy {
    @apply happy-purple-gradient:text-bg-happy-light;
}

.price-product-basket-happy {
    @apply font-semibold text-button-yellow-happy-light;
    @apply happy-bee-light:text-text-dark-happy-light;
    @apply happy-bee-dark:text-text-dark-happy-light;
    @apply happy-scorched-earth:text-urban-dark;
    @apply happy-gray-sand:text-urban-dark;
    @apply happy-purple-gradient:text-bg-happy-light;
}

@media screen and (min-height: 400px) {
    .div-modal-basket-content-happy {
        @apply max-h-[14rem];
    }
}
@media screen and (min-height: 500px) {
    .div-modal-basket-content-happy {
        @apply max-h-[18rem];
    }
}
@media screen and (min-height: 600px) {
    .div-modal-basket-content-happy {
        @apply max-h-[24rem];
    }
}
@media screen and (min-height: 700px) {
    .div-modal-basket-content-happy {
        @apply max-h-[28rem];
    }
}

@media screen and (min-width: 376px) {
    .section-modal-basket-content-happy {
        /* @apply ; */
        /* @apply; */
    }
}

@media screen and (min-width: 400px) {
    .section-modal-basket-content-happy {
        @apply w-[24.9rem];
    }
}

@media screen and (min-width: 550px) {
    .section-modal-basket-content-happy {
        @apply right-12;
    }
}

@media screen and (min-width: 1300px) {
    .section-modal-basket-content-happy {
        @apply right-16;
    }
}

@media screen and (min-width: 1400px) {
    .section-modal-basket-content-happy {
        @apply right-28;
    }
}

@media screen and (min-width: 1500px) {
    .section-modal-basket-content-happy {
        @apply right-44;
    }
}

@media screen and (min-width: 1600px) {
    .section-modal-basket-content-happy {
        @apply right-52;
    }
}

@media screen and (min-width: 1700px) {
    .section-modal-basket-content-happy {
        @apply right-64;
    }
}

@media screen and (min-width: 1800px) {
    .section-modal-basket-content-happy {
        @apply right-80;
    }
}

@media screen and (min-width: 2000px) {
    .section-modal-basket-content-happy {
        @apply right-96;
    }
}

@media screen and (min-width: 2100px) {
    .section-modal-basket-content-happy {
        @apply right-[32rem];
    }
}
@media screen and (min-width: 2400px) {
    .section-modal-basket-content-happy {
        @apply right-[39rem];
    }
}

@media (hover: hover) {
    .svg-cross-modal-basket-happy:hover {
        @apply stroke-border-red-happy-light;
        @apply happy-orange-light:stroke-bg-orange;
        @apply happy-orange-dark:stroke-bg-orange;
        @apply happy-fresh-mint:stroke-bg-mint;
        @apply happy-bee-light:stroke-bee-yellow;
        @apply happy-bee-dark:stroke-bee-yellow;
        @apply happy-earth-stone:stroke-earth-card;
        @apply happy-scorched-earth:stroke-scorched-earth-red;
        @apply happy-sand-sky:stroke-sand-blue-dark;
        @apply happy-gray-sand:stroke-white;
        @apply happy-purple-gradient:stroke-pink-light;
    }

    .bottom-basket-modal-happy:enabled:hover {
        @apply bg-text-dark-happy-light text-bg-happy-light;
        @apply happy-urban-dark-red:border-urban-red-dark happy-urban-dark-red:bg-urban-red-dark happy-urban-dark-red:text-bg-happy-light;
        @apply happy-urban-light-red:border-urban-red-dark happy-urban-light-red:bg-urban-red-dark happy-urban-light-red:text-bg-happy-light;
        @apply happy-orange-light:border-bg-orange-dark happy-orange-light:bg-bg-orange-dark happy-orange-light:text-bg-happy-light;
        @apply happy-orange-dark:border-bg-orange-dark happy-orange-dark:bg-bg-orange-dark happy-orange-dark:text-bg-happy-light;
        @apply happy-fresh-mint:border-bg-mint-dark happy-fresh-mint:bg-bg-mint-dark happy-fresh-mint:text-bg-happy-light;
        @apply happy-bee-light:border-bee-yellow-dark happy-bee-light:bg-bee-yellow-dark happy-bee-light:text-bg-happy-light;
        @apply happy-bee-dark:border-bee-yellow-dark happy-bee-dark:bg-bee-yellow-dark happy-bee-dark:text-bg-happy-light;
        @apply happy-earth-stone:border-earth-card happy-earth-stone:bg-earth-card happy-earth-stone:text-bg-happy-light;
        @apply happy-scorched-earth:border-scorched-earth-red happy-scorched-earth:bg-scorched-earth-red happy-scorched-earth:text-bg-happy-light;
        @apply happy-sand-sky:border-sand-blue-dark happy-sand-sky:bg-sand-blue-dark happy-sand-sky:text-bg-happy-light;
        @apply happy-gray-sand:bg-gray-sand-gray-light happy-gray-sand:text-urban-dark;
        @apply happy-purple-gradient:border-pink-light happy-purple-gradient:bg-pink-light happy-purple-gradient:text-urban-dark;
    }

    .bottom-basket-modal-happy:enabled:hover div .price-product-basket-happy {
        @apply happy-bee-light:text-bg-happy-light;
        @apply happy-bee-dark:text-bg-happy-light;
        @apply happy-purple-gradient:text-urban-dark;
    }

    .bottom-basket-modal-happy:enabled:hover div .price-product-basket-happy,
    .bottom-basket-modal-happy:enabled:hover div .price-product-basket-happy {
        @apply happy-bee-light:text-bg-happy-light;
        @apply happy-bee-dark:text-bg-happy-light;
        @apply happy-scorched-earth:text-bg-happy-light;
    }

    .bottom-basket-modal-happy:enabled:hover div .svg-basket-happy {
        @apply happy-scorched-earth:fill-scorched-earth-yellow;
        @apply happy-purple-gradient:fill-urban-dark;
    }
    .bottom-basket-modal-happy:enabled:hover div div .p-count-basket-happy {
        @apply happy-purple-gradient:text-bg-happy-light;
    }
}
</style>
